import { useContext, useEffect, useMemo, useState } from 'react'

import { DueDateCardEmbed, useHealthToolsCache } from '@hhgtech/hhg-components'
import { ReviewedUserApi } from '@hhgtech/hhg-components/build/together/interfaces/types'
import { BoxProps } from '@mantine/core'
import { formatUserProfileUrl } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, getApiPath, redirectToSSOWithReturnUrl } from 'api/utils'
import { DueDateInfoType } from 'components/organisms/embededHeathToolCards/due-date'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { HEALTH_TOOL_TYPE } from 'interfaces/constants'
import { DueDateInfo } from 'interfaces/types'
import { AppContext } from 'state/appContext'

type Props = {
  isSide?: boolean
} & BoxProps
export const DueDateCardEmbeded = ({ isSide, ...props }: Props) => {
  const isMobile = useIsMobile()
  const { locale } = useRouterExtend()
  const { getHealthToolLink } = useHealthToolsCache(locale + '_MB')
  const dueDateLink = useMemo(
    () => getHealthToolLink(HEALTH_TOOL_TYPE.DUE_DATE),
    [getHealthToolLink],
  )

  const { state } = useContext(AppContext) || {}
  const { userInfo } = state || {}
  const [dueDatePageInfo, setDueDatePageInfo] = useState<DueDateInfo>(
    {} as DueDateInfo,
  )

  const [expertUrl, setExpertUrl] = useState('')
  const currentUrl = useCurrentUrl()

  useEffect(() => {
    ;(async () => {
      const res = await callApi(getApiPath(PATHS.GET_DUE_DATE_INFO), 'GET')
      setDueDatePageInfo(res?.data)
      setExpertUrl(
        formatUserProfileUrl(res?.data?.reviewed_by as ReviewedUserApi) || '',
      )
    })()
  }, [])

  const onSubmitDueDate = (_: DueDateInfoType, redirectQuery?: string) => {
    const destination = `${dueDateLink}?${redirectQuery}`

    if (!userInfo?.id) {
      return redirectToSSOWithReturnUrl(
        `${window.location.origin}${destination}`,
        'due-date',
      )
    }

    window.location.href = destination
  }
  if (!dueDateLink)
    return (
      <div
        style={{
          height: 500,
        }}
      />
    )
  return (
    <DueDateCardEmbed
      dueDatePageInfo={dueDatePageInfo}
      expertUrl={expertUrl}
      formProps={
        {
          isMobile,
          formLayout: isMobile || isSide ? 'default' : 'inline',
          onSubmit: onSubmitDueDate,
          submitProps: {
            dataEventLabel: currentUrl,
          },
        } as any
      }
      onSubmitDueDate={onSubmitDueDate}
      {...props}
    />
  )
}
